import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


const __default__ = {
  name: "MPopper"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  content: {
    type: String,
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false
  },
  placement: {
    type: String,
    default: 'top'
  },
  trigger: {
    type: String,
    default: 'hover'
  }
},
  setup(__props) {

const props = __props;




return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createBlock(_component_el_popover, _mergeProps(_ctx.$attrs, {
    "popper-class": "self-popper",
    width: "auto",
    disabled: !__props.disabled,
    placement: __props.placement,
    trigger: __props.trigger,
    content: __props.content
  }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    reference: _withCtx(() => [
      _renderSlot(_ctx.$slots, "reference")
    ]),
    _: 3
  }, 16, ["disabled", "placement", "trigger", "content"]))
}
}

})